import React, { useEffect, useState } from "react";
import Image from "../../assets/image/png/blog-image.png";
import { useDispatch, useSelector } from "react-redux";
import { getBlogs } from "../../redux/slice/blogSlice";
import HTMLReactParser from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { getTenders } from "../../services/TenderServices";

const AllTenders = () => {
  const [tenders, setTenders] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const navigate = useNavigate();
  const [isBlurred, setIsBlurred] = useState(false);

  useEffect(() => {
    getTenders(page).then((res) => {
      setTenders(res?.data?.tenders);
      setTotalPage(res?.data?.pagination?.totalPages);
    });
  }, [page]);

  function descriptionShort(item) {
    // Get the first 100 characters of description
    const first100Chars = `${item.description.slice(0, 100)}...`;
    return first100Chars;
  }

  function formatDate(inputDate) {
    const months = [
      "JANUARY",
      "FEBRUARY",
      "MARCH",
      "APRIL",
      "MAY",
      "JUNE",
      "JULY",
      "AUGUST",
      "SEPTEMBER",
      "OCTOBER",
      "NOVEMBER",
      "DECEMBER",
    ];

    // Parse the input date string
    const date = new Date(inputDate);

    // Extract the month, day, and year
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    // Format the date in the desired format
    const formattedDate = `${month.toUpperCase()} ${day}, ${year}`;

    return formattedDate;
  }

  return (
    <div id="overview">
      {/* Coming Soon Overlay */}
      <div
        id="coming-soon-overlay"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "2rem",
          fontWeight: "bold",
          color: "#fff",
          zIndex: 1000,
          opacity: 1, // Ensure text is not blurry
        }}
      >
        Coming Soon
      </div>

      {/* Blocker to prevent interactions */}
      <div
  id="overlay-blocker"
  style={{
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent background
    zIndex: 999,
    filter: "blur(5px)", // Apply the blur effect
  }}
></div>


      {/* Header Section */}
      <div className="header-section bg-darkblue text-white py-4">
        <div className="container">
          <h1 className="ff_inter fw-bold">Tenders and News</h1>
          <p className="fs_18">Stay updated with the latest Tenders & News</p>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="custom-navbar custom-navbar-expand custom-navbar-light">
        <div className="custom-navbar-container">
          <div className="custom-navbar-nav">
            <a className="custom-nav-item custom-nav-link" href="#Tenders">Tenders</a>
            <a className="custom-nav-item custom-nav-link" href="#News/Blogs">News/Blogs</a>
            <a className="custom-nav-item custom-nav-link" href="#Announcement">Announcement</a>
            <a className="custom-nav-item custom-nav-link" href="#Schemes">Schemes</a>
            <a className="custom-nav-item custom-nav-link" href="#Events">Events</a>
          </div>
        </div>
      </nav>

      {/* Tenders Section */}
      <div className="container">
        <h2 className="ff_inter pt-5 fw-bold" style={{ textAlign: "center" }}>Tenders</h2>

        <div className="row pb-5">
          {tenders.map((item, index) => {
            return (
              <div className="col-sm-6 col-md-6 p-3" key={index}>
                <div
                  onClick={() => navigate(`/tender-details/${item._id}`)}
                  className="d-flex p-3 bg-white rounded-3 h-100 cursor_pointer"
                >
                  {/* Image on the left */}
                  <div className="tender-image">
                    <img
                      className="rounded-3 w-100 object-fit-cover"
                      height={200}
                      src={item.image}
                      alt={item.title}
                    />
                  </div>

                  {/* Text content on the right */}
                  <div className="tender-text ms-3">
                    {/* Title */}
                    <p className="color_blue fw-bold ff_helvetica fs_15 title-text">
                      {item.title}
                    </p>

                    {/* Description */}
                    <p className="color_darkgray fs_18 ff_helvetica description-text">
                      {item?.description ? HTMLReactParser(descriptionShort(item)) : ""}
                      <span
                        className="read-more"
                        onClick={() => navigate(`/tender-details/${item._id}`)}
                      >
                        Read More
                      </span>
                    </p>

                    {/* Date */}
                    <p className="mt-3 color_black fw-light ff_helvetica fs_13" style={{ textAlign: "end" }}>
                      {formatDate(item.updatedAt)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Popular Blog and News Section */}
      <div className="container">
        <h2 className="ff_inter pt-5 fw-bold" style={{ textAlign: "center" }}>Popular Blog and News</h2>

        <div className="row pb-5">
          {/* Flex container to hold main and side tenders */}
          <div className="d-flex flex-wrap">
            {/* Left Side: Main Tender */}
            <div className="col-lg-8 col-md-12 p-3">
              {tenders.map((item, index) => {
                if (index === 0) {
                  return (
                    <div key={index} className="d-flex flex-column bg-white rounded-3 main-tender p-3 cursor-pointer">
                      {/* Main Image */}
                      <div className="tender-image-container">
                        <img
                          className="rounded-3 object-fit-cover main-tender-image"
                          src={item.image}
                          alt={item.title}
                        />
                      </div>

                      {/* Title and Description */}
                      <div className="tender-text ms-3 mt-3">
                        <p className="color_blue fw-bold ff_helvetica fs_7 title-text">{item.title}</p>
                        <p className="color_darkgray fs_5 ff_helvetica description-text">
                          {item?.description ? HTMLReactParser(descriptionShort(item)) : ""}
                          <span
                            className="read-more"
                            onClick={() => navigate(`/tender-details/${item._id}`)}
                          >
                            Read More
                          </span>
                        </p>
                        <p className="mt-3 color_black fw-light ff_helvetica fs_13" style={{ textAlign: "end" }}>
                          {formatDate(item.updatedAt)}
                        </p>
                      </div>
                    </div>
                  );
                }
                return null;
              })}
            </div>

            {/* Right Side: 3 Side Tenders */}
            <div className="col-lg-4 col-md-12 p-3">
              <div className="row">
                {tenders.slice(1, 4).map((item, index) => {
                  return (
                    <div key={index} className="col-12 p-3">
                      <div
                        onClick={() => navigate(`/tender-details/${item._id}`)}
                        className="d-flex bg-white rounded-3 h-100 cursor-pointer side-tender"
                      >
                        {/* Image on the Left */}
                        <img
                          className="rounded-3 side-tender-image"
                          height={100}
                          src={item.image}
                          alt={item.title}
                        />

                        {/* Content on the Right */}
                        <div className="side-tender-text">
                          <p className="color_blue fw-bold ff_helvetica fs_15">{item.title}</p>
                          <p className="color_darkgray fs_14 ff_helvetica">
                            {item?.description ? HTMLReactParser(descriptionShort(item)) : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Announcement Section */}
      <div>
        <h2 className="ff_inter pt-5 fw-bold" style={{ textAlign: "center" }}>Announcement</h2>

        <div className="row pb-5" style={{ display: "flex", flexWrap: "wrap" }}>
          {tenders.map((item, index) => {
            return (
              <div
                className="col-sm-6 col-md-6 p-3"
                key={index}
                style={{
                  flex: "0 0 33.33%",
                  boxSizing: "border-box",
                  padding: "15px",
                }}
              >
                <div
                  onClick={() => navigate(`/tender-details/${item._id}`)}
                  className="d-flex flex-column p-3 bg-white rounded-3 h-100 cursor_pointer"
                >
                  {/* Image on top */}
                  <div className="tender-image" style={{ marginBottom: "15px", width: "100%" }}>
                    <img
                      className="rounded-3 w-100 object-fit-cover"
                      height={250}
                      src={item.image}
                      alt={item.title}
                      style={{ width: "100%" }}
                    />
                  </div>

                  {/* Text content below the image */}
                  <div className="tenders-text">
                    {/* Title */}
                    <p className="color_blue fw-bold ff_helvetica fs_15 title-text">
                      {item.title}
                    </p>

                    {/* Description */}
                    <p className="color_darkgray fs_18 ff_helvetica description-text">
                      {item?.description ? HTMLReactParser(descriptionShort(item)) : ""}
                      <span
                        className="read-more"
                        onClick={() => navigate(`/tender-details/${item._id}`)}
                        style={{ color: "#007BFF", cursor: "pointer" }}
                      >
                        Read More
                      </span>
                    </p>

                    {/* Date */}
                    <p className="mt-3 color_black fw-light ff_helvetica fs_13" style={{ textAlign: "end" }}>
                      {formatDate(item.updatedAt)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Schemes Section */}
      <div>
        <h2 className="ff_inter pt-5 fw-bold" style={{ textAlign: "center" }}>Schemes</h2>

        <div className="row pb-5" style={{ display: "flex", flexWrap: "wrap" }}>
          {tenders.map((item, index) => {
            return (
              <div
                className="col-sm-6 col-md-6 p-3"
                key={index}
                style={{
                  flex: "0 0 33.33%",
                  boxSizing: "border-box",
                  padding: "15px",
                }}
              >
                <div
                  onClick={() => navigate(`/tender-details/${item._id}`)}
                  className="d-flex flex-column p-3 bg-white rounded-3 h-100 cursor_pointer"
                >
                  {/* Image on top */}
                  <div className="tender-image" style={{ marginBottom: "15px", width: "100%" }}>
                    <img
                      className="rounded-3 w-100 object-fit-cover"
                      height={250}
                      src={item.image}
                      alt={item.title}
                      style={{ width: "100%" }}
                    />
                  </div>

                  {/* Text content below the image */}
                  <div className="tenders-text">
                    {/* Title */}
                    <p className="color_blue fw-bold ff_helvetica fs_15 title-text">
                      {item.title}
                    </p>

                    {/* Description */}
                    <p className="color_darkgray fs_18 ff_helvetica description-text">
                      {item?.description ? HTMLReactParser(descriptionShort(item)) : ""}
                      <span
                        className="read-more"
                        onClick={() => navigate(`/tender-details/${item._id}`)}
                        style={{ color: "#007BFF", cursor: "pointer" }}
                      >
                        Read More
                      </span>
                    </p>

                    {/* Date */}
                    <p className="mt-3 color_black fw-light ff_helvetica fs_13" style={{ textAlign: "end" }}>
                      {formatDate(item.updatedAt)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Business and Entrepreneurship Section */}
      <div>
        <h3 style={{ textAlign: "center", fontSize: "15px", color: "blue", marginBottom: "-40px" }}>
          Business and Entrepreneurship
        </h3>
        <h2 className="ff_inter pt-5 fw-bold" style={{ textAlign: "center" }}>
          Building a Successful Startup<br />Lessons from the Trenches
        </h2>

        <div className="row pb-5" style={{ display: "flex", justifyContent: "center" }}>
          {/* Display only the first tender image */}
          {tenders.length > 0 && (
            <div
              className="col-12 p-3"
              style={{
                flex: "0 0 100%",
                boxSizing: "border-box",
                padding: "15px",
                textAlign: "center",
              }}
            >
              <div
                onClick={() => navigate(`/tender-details/${tenders[0]._id}`)}
                className="d-flex flex-column p-3 bg-white rounded-3 h-100 cursor-pointer"
              >
                {/* Large Image Only */}
                <div className="tender-image" style={{ marginBottom: "15px", width: "100%" }}>
                  <img
                    className="rounded-3 w-100 object-fit-cover"
                    height={300}
                    src={tenders[0].image}
                    alt={tenders[0].title}
                    style={{ width: "90%" }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllTenders;